export default function NotFound() {
    window.location.href = '/'
    return <h1>Not Found</h1>
}
